module.exports = __webpack_public_path__ + "static/media/CHAP00-INFOG-SAM-JOUEURS.18d1e9cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/CHAP00-INFOG-SAM-JOUEURS.png
// module id = 246
// module chunks = 0